import { render, staticRenderFns } from "./AppWarnOnLeave.vue?vue&type=template&id=47fb7c8e&"
import script from "./AppWarnOnLeave.vue?vue&type=script&lang=js&"
export * from "./AppWarnOnLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports